module.exports = __webpack_public_path__ + "6d8e52d8caad4cdb034afc0d76987f5d.svg";